module.exports = function() {
  return new Worker(__webpack_public_path__ + "4ab4666a402cc9b68929.worker.js");
};